import Vue from 'vue';

const pasttense = value => {
  var vowels = ['a', 'e', 'i', 'o', 'u'];
  if (!value) {
    return;
  }

  var last = value.toLowerCase().substr(value.length - 1),
    secondLast = value.toLowerCase().substr(value.length - 2, 1),
    thirdLast = value.toLowerCase().substr(value.length - 3, 1),
    lastTwo = value.toLowerCase().substr(value.length - 2),
    lastThree = value.toLowerCase().substr(value.length - 3),
    inArray = function(ar, value) {
      return ar.indexOf(value) != -1;
    };

  // participle or already past tense, don't want
  if (lastThree === 'ing' || lastTwo === 'ed') {
    return value;
  }

  // Ends in 'e', simply add the 'd'
  if (last === 'e') {
    return value + 'd';
  }

  // Ends in 'c', add the 'ked'
  if (last === 'c') {
    return value + 'ked';
  }

  // Ends with consonant, vowel, consonant. I'm simple, double consonant and add 'ed'
  if (
    !inArray(vowels, thirdLast) &&
    inArray(vowels, secondLast) &&
    !inArray(vowels, last) &&
    last !== 'n'
  ) {
    return value + last + 'ed';
  }

  return value + 'ed';
};
export default pasttense;

Vue.filter('pasttense', pasttense);
